// China
export const locale = {
  TRANSLATOR: {
    SELECT: "选择你的语言"
  },
  AUTH: {
    TIPS: {
      MESSAGE: "提示消息",
      REFRESH: "请刷新重试",
      REPEAT: "该email已经存在",
      REGISTERTWO:"账户已注册!",
      SUCCESS: "操作成功，请登录",
      INEXISTENCE: "不存在该账号，请注册",
      FAIL: "账号或者密码错误",
      CONFIMPASS: "确认密码应该和密码保持一致",
      CONSENTCLAUSE: "请同意注册条款",
      COUNTRY:"国家",
      REQUIRE_TYPE:"需求类型",
      ANNUAL_DEMAND:"年需求量",
      PRODESSION:"行业",
    },
    ICLOUD: {
      NAME_TOP: "PCB在线报价下单",
      NAME_FOOT: "平台"
    },
    GENERAL: {
      WELCOME: "欢迎登录领德平台",
      SUBMIT_BUTTON: "登录",
      INQUIRY_BUTTON: "询价",
      NO_ACCOUNT: "没有账号？",
      SIGNUP_BUTTON: "注册",
      FORGOT_BUTTON: "忘记密码",
      PRIVACY: "隐私",
      LEGAL: "法律",
      CONTACT: "联系"
    },
    INPUT: {
      EMAIL: "邮箱",
      PASSWORD: "密码",
      FULLNAME: "名称",
      COMPANY: "公司",
      CONFIRM_PASSWORD: "确认密码",
      ADDRESS: "地址",
      LINKMAN: "联系人",
    },
    VALIDATION: {
      EMAIL: "请填写正确的邮箱",
      PASSWORD: "请填写正确的密码",
      FULLNAME: "请填写正确的名称",
      COMPANY: "请填写正确的公司",
      ADDRESS: "请填写正确的地址",
      LINKMAN: "请填写正确的联系人",
      CONFIMPASS: "请填写正确的密码，并和密码一致",
    },
    FORGOT: {
      TITLE: "忘记密码?",
      DESC: "请输入你的邮箱进行重置密码",
      SUCCESS: "修改密码成功",
      SUBMIT_BUTTON: "修改",
      CANCEL_BUTTON: "取消",
      CONFIRM_BUTTON: "确定",
    },
    REGISTER: {
      TITLE: "注册",
      DESC: "请录入信息创建你的账号",
      SUCCESS: "成功注册账号",
      SUBMIT_BUTTON: "注册",
      CANCEL_BUTTON: "取消",
      CONDITION_TOP: "同意",
      CONDITION_FOOT: "隐私和条款",
    },
  },
  MENU: {
    NEW: "新",
    ACTIONS: "行动",
    CREATE_POST: "创建新帖子",
    PAGES: "Pages",
    FEATURES: "特征",
    APPS: "应用",
    DASHBOARD: "仪表板"
  },
  CONTENT:{
    REDMSG: "请录入红色星号必选项",
    System_Management:"系统管理",
    MAKE_OFFERS:"下单",
    MY_INFORNATIONAL:"我的信息",
    TO_BE_CONFIRM: "待确认",
    To_Be_Audit:"待审核",
    CONFIRM:"确认",
    See_More:"更多",
    To_Be_Payment:"待付款",
    Payment:"付款",
    Order_Management:"订单管理",
    Edit:"编辑",
    Delete:"删除",
    View:"查看",
    Audit:"审核",
    Pay_Comfirm:"付款确认",
    Withdraw:"撤回",
    SELECT_ORDER_TYPE:"请选择订单类型!",
    Sample_Prompt:"样品面积不能大于0.1㎡！",
    SELECT_ITEM_VALUE:"内容不能为空！",
    PnlLength:"规格尺寸长不能为空！",
    PnlWidth:"规格尺寸宽不能为空！",
    Quantity:"数量不能为空！",
    Brand:"品牌不能为空！",
    Product:"请配置产品！",
    Repulse:"打回",
    No_content_was_matched:"未匹配到内容!",
    No_attachment_selected:"未选择附件，是否继续下单"
  },
  USER:{
    User_Profile:"个人中心",
    Logout:"退出登录",
    Home_Page:"首页",
    Avatar:"头像"
  },
  BOTTOM:{
    About:"关于",
    TEAM:"团队",
    Contact:"合同",
    LEADCLOUD:"领德平台",
    Contact_Platform:"联系平台",

  },
  ACCOUNT:{
    Account_Information:"账户信息",
    Save_Changes:"保存",
    Cancel:"取消",
    Account:"账户",
    Fullname:"全称",
    Email:"邮箱",
    corporation:"公司",
    Address:"地址",
    Linkman:"联系人",
    Language:"语言",
    Select_Language:"选择语言",
    English:"英文",
    Simplified_Chinese:"简体中文",
    Weekly_Income:"累计下单金额",
    Sales_Change:"累计下单面积",
    Change_your_account_settings:"更改账户信息",
    gender:"性别",
    phone:"电话",
    industry:"行业",
    webUrl:"网站",
    Upload_pictures:"上传附件"
  },
  PRICE:{
    PRODUCT:"产品",
    CRAFT_ORDER:"工艺参数",
    Order:"立即计价",
    OrderTwo:"下单",
    Automobile_lighting:"汽车照明",
    Outdoor_lighting:"户外照明",
    Plant_lighting:"植物照明",
    Plate_type:"板材类型",
    Number_Board_layers:"板子层数",
    Board_Size:"板子尺寸",
    The_number_of_pieces:"拼版款数",
    quantity:"数量",
    Shipping_method:"出货方式",
    Board_thickness:"板子厚度",
    Solder_resistance_color:"阻焊颜色",
    Character_color:"字符颜色",
    Exposure_screen_printing:"曝光/丝印",
    Outer_copper_thickness:"外层铜厚",
    Pad_spray_plating:"焊盘喷镀",
    Line_test:"线路测试",
    Forming_method:"成型方式",
    Area:"面积",
    Number_boards:"板子数量",
    Heat_conduction:"导热",
    Withstand_voltage:"耐压",
    Special_technology:"特殊工艺",
    Special_requirements:"特殊要求",
    Select_material_brand:"选择材料品牌",
    Specification_parameter:"规格参数",
    Select_express:"选择快递",
    Order_date:"下单日期",
    Estimated_delivery:"预计发货",
    Estimated_price:"估算价格",
    Order_delivery_date:"订单交期",
    Total_amount:"总金额",
    Exchange_rate:"汇率",
    Order_agreement:"下单协议",
    Material_fee_and_other_background_confirmation:"材料费等后台确认"
  },
  PRICECONENT:{
    Drup:"卓普",
    Nobutaka:"伸丰",
    Shengyi:"生益",
    Aluminium_base:"铝基",
    Single_side:"单面",
    two_sided:"双面",
    Exposure:"曝光",
    Screen_printing:"丝印",
    Antioxidant:"抗氧化",
    Gild:"镀金",
    Spray_lead_free_tin:"喷无铅锡",
    Sprayed_with_lead_tin:"喷有铅锡",
    Heavy_gold:"沉金",
    Copper_rosin:"铜皮松香",
    Silvering:"镀银",
    Manual_visual_inspection:"人工目测",
    Computer_test:"电脑测试",
    Flying_needle_test:"飞针测试",
    New_test_rack:"新开测试架",
    Rack_test:"测试架测试",
    Scan:"扫描",
    Jointed_board:"拼版",
    Finished_product:"成品",
    Price:"单价",
    Freight:"运费",
    Express_delivery:"快递",
    ageing:"时效",
    stamping:"模冲",
    computer:"电脑",
    CNC_v_threading:"数控V穿",
    Reinforced_packing:"加强包装",
    Withstand_voltage_measurement:"测耐压",
    stripping:"撕膜",
    superpore:"超孔",
    Crosses_are_not_accepted:"不接受打叉",
    Erasure_is_not_accepted:"不接受擦花",
    Dot_copper_leakage_is_not_accepted:"不接受星点漏铜",
    Do_not_accept_the_Philin_seal:"不接受菲林印",
    Do_not_accept_the_fork_wipe_copper_leakage:"不接受打叉擦花漏铜等",
    Single_piece_data_single_piece_shipment:"单片资料单片出货",
    Shipment_according_to_customer_information:"按客户资料拼版出货",
    Lead_the_virtue_to_fight:"领德代拼",
    Sf_Express:"顺丰",
    flexible:"圆通",
    Sto_Express:"申通",

  },
  COLOR:{
  Green:"绿色",
  High_anti_white_oil:"高反白油",
  Black:"黑色",
  Blue:"蓝色",
  Yellow:"黄色",
  Red:"红色",
  Purple:"紫色",
  White:"白色",
  Without:"无",
  },
  ORDER:{
    My_order:"我的订单",
    inquire:"查询",
    derive:"导出",
    confirm:"确认",
    Order_Information:"订单信息",
    Price:"价格",
    Order_Attachment:"订单附件",
    Order_progress:"订单进度",
    Controls:"操作",
    LEADCLOUD:"领德平台",
    Product_technology:"产品工艺",
    Order_status:"订单状态",
    Information_Manage:"信息管理",
    Confirm_The_Order:"订单确认",
    Sales_Order:"确定要确认订单吗？",
    Delete_Order:"删除订单",
    Cancel_Order:"确定要删除订单吗?",
    Audit_The_Order:"订单审核",
    Audit_Order:"确定要审核订单吗？",
    Pay_Confirm_The_Order:"订单付款确认",
    Pay_Sales_Order:"确定要确认付款订单吗？",
    Upload_file:"附件管理",
    File_list:"文件列表",
    Order_back:"打回订单",
    Make_sure_to_return_the_order:"确定要打回订单吗？"
  },
  ONLINE:{
    Product_Type:"产品类型",
    SIZE:"尺寸",
    LENGTH:"长",
    WIDTH:"宽",
    Specification_Size:"规格尺寸",
    Concatenation_Number:"拼接数",
    QUANTITY:"数量",
    Order_Type:"订单类型",
    New_Order:"新单",
    REORDER:"返单",
    Currency_Type:"货币类型",
    Process_Validation:"工艺确认",
    Quotation_details:"报价明细",
    RMB:"人民币",
    PICTURE:"图片",
    DOCUMENT:"文件",
    Large_Text:"大文本",
    Customer_Name:"客户名称",
    specification:"规格",
    area:"面积",
    amount:"金额",
    Order_Time:"下单时间",
    Order_Delivery_Time:"订单交期",
    status:"状态",
    Order_Progress:"订单进度",
    Controls:"操作",
    To_be_confirmed:"待确认",
    Pending_Approval:"待审核",
    due:"待付款",
    In_Production:"生产中",
    unconfirmed:"未确认",
    Order_Number:"订单编号",
    Offline_Transfer:"线下转账",
    file:"文件",
    upload:"附件管理",
    View_upload:"查看上传",
    delete:"删除",
    confirm:"确定",
    Cancel:"取消",
    attachments:"附件",
    Download:"下载",
    Preview:"预览",
    Please_Select_An_Order:"请选择订单",
    Do_Not_Click_More_Than_Once:"请勿多次点击",
    Hit_Back:"打回成功",
    Confirm_Success:"确认成功!",
    Successful_Audit:"审核成功!",
    Payment_Confirmation_Successful:"待付款确认成功!",
    Please_refresh_and_retry:"请刷新重试!",
    Successfully_deleted:"删除成功!",
    Save_successfully:"保存成功!",
    Already_exist:"已经存在",
    Upload_only:"只能上传",
    File_name_extension:"后缀名的文件",
    System_error:"系统错误",
    Please_select_a_currency_type:"请选择货币类型",
    Reset_password_successfully:"重置密码成功",
    Failed_to_reset_password:"重置密码失败",
    Please_enter_email:"请输入邮箱",
    male:"男",
    female:"女",
    Please_log_in:"请登录",
    Upload_successfully:"上传成功",
    Upload_failed_please_refresh_and_try_again:"上传失败，请刷新重试！",
    The_file_name_has_been_uploaded:"该文件名已经上传",
    The_order_is_going_through_production:"订单正在进行生产过数",
    The_order_has_been_placed:"订单已投料",
    Orders_have_been_made_for_engineering_cards:"订单已制作工程卡",
    Order_has_been_approved:"订单已审批",
    Attachment_management:"上传",
    Upload_attachment:"上传附件",
    Please_enter_a_number_that_cannot_be_less_than_zero:"请输入数字并且不能小于零!",
    Data_files:"资料文件",
    Computer_upload:"电脑上传",
    Upload_attachments:"上传资料"
},
  CRAFTVALUE:{
    NickName:"名称",
    ContactEmail:"联系邮箱",
    MobilePhone:"手机号码",
    COUNTRY:"国家",
    Annual_demand:"年需求量",
    Profession:"产品应用",
    Quote_immediately:"马上报价",
    Add_quoted_items_by_material_process:"按材料工艺增加报价项目",
    Augment:"增加",
    Quotation_list:"报价清单",
    Unit_price_per_square_meter:"平米单价",
    Delete:"删除",
    Quoted_item:"报价项目",
    Close:"关闭",
    Verify:"确认",
    Item_type:"项目类型",
    Item_selection:"项目选择",
    PCB_type:"PCB类型",
    Copper_clad_sheet:"覆铜板材",
    Sheet_thickness:"板材厚度",
    Copper_coating_requirement:"覆铜要求",
    Coating_treatment:"镀层处理",
    Solder_resistance_type:"阻焊类型",
    Panel_character:"板面字符",
    Forming_method:"成型方式",
    Test_requirement:"测试要求",
    Yuan:"元",
    Personal_information:"个人信息",
    You_have_registered_successfully_account:"你已注册成功,账号",
    Password:"密码",
    You_can_go_to_the_top_left_page_to_specify_an_order:"可以去左上角首页指定下单",
    Amount:"金额",
    Area:"面积",
    Download:"下载",
  },
  QUOTATION:{
    Offer:"报价",
    Material_classification:"材料分类",
    Process_classification:"工艺分类",
    Process_information:"工艺信息",
    Bid_successful:"报价成功!",
    Unit:"单位",
    CustomerName:"客户名称",
    View_quote_history:"报价记录",
    No_permission_to_view_quotation_records:"暂无权限查看报价记录!",
    Quotation_record:"报价记录",
    Click_on_the_blue_price_below_to_modify_it:"点击下面蓝色价格可进行修改"
  }



};
